export default "__VITE_ASSET__BvJ0W0A3__"